import React from 'react';
import Navbar from '../../components/Navbar';
import LogInForm from '../LogInForm.jsx';

const LogIn = () => {
  return (
    <div>
      <Navbar />
      <LogInForm />
    </div>
  );
}

export default LogIn;